import { CircleButton, Flex, Icon, Title } from '@bb/elements-web';
import moment, { type Moment } from 'moment';
import React from 'react';

type DateSelectorHeaderProps = {
  selectedDate: Moment;
  setSelectedDate: (m: Moment) => void;
};

const DateSelectorHeader: React.FC<DateSelectorHeaderProps> = ({
  selectedDate,
  setSelectedDate,
}) => (
  <Flex align="center" justify="space-around">
    <CircleButton
      dataCy="calendar-prevMonthBtn"
      type="text"
      onClick={() => setSelectedDate(moment(selectedDate).subtract(1, 'month'))}
      icon={<Icon icon="arrowLeftOutlined" size={16} />}
    />
    <Title level={4} dataCy="calendar-monthText">
      {selectedDate.format('MMMM YYYY')}
    </Title>
    <CircleButton
      dataCy="calendar-nextMonthBtn"
      type="text"
      onClick={() => setSelectedDate(moment(selectedDate).add(1, 'month'))}
      icon={<Icon icon="arrowRightOutlined" size={16} />}
    />
  </Flex>
);

export default DateSelectorHeader;
